import { useQuery } from "@tanstack/react-query";

import { ICON_STROKE, Sparkles } from "@/shared/components/icons";
import { fetchProfileSummary } from "@/shared/api";
import { composeIdentityLine } from "@/features/skills/lib/skillStats";

/** The player-identity line — a one-glance "who you are at the table",
 *  composed from the backend's structured identity fields. Hidden until the
 *  identity is `ready` (enough signal to make a credible claim). */
export function IdentityLine() {
  const { data } = useQuery({ queryKey: ["profile-summary"], queryFn: fetchProfileSummary });
  const identity = data?.identity;
  const lines = identity ? composeIdentityLine(identity) : null;
  if (!lines) return null;

  return (
    <section className="rounded-xl border border-accent/30 bg-accent/5 p-4 flex items-start gap-3">
      <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-accent/15 text-accent flex-shrink-0">
        <Sparkles size={15} strokeWidth={ICON_STROKE} />
      </span>
      <div className="min-w-0">
        <div className="text-sm font-medium text-text">{lines.strength}</div>
        {lines.focus && <div className="text-xs text-text-muted mt-0.5">{lines.focus}</div>}
      </div>
    </section>
  );
}
